module.exports = __webpack_public_path__ + "img/TAJ-Hotel-Wayanad.09d79d97.jpg";